import Enum from "./Enum";

export default Enum.create( {
	HORIZONTAL: "HORIZONTAL",
	VERTICAL: "VERTICAL",
} );
